import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetchManageSubscriptionData, SubscriptionParamTypes } from './fetchManageSubscriptionData';
import { browserClient } from '../../react-query';
import { SubscriptionManagementPageDataOut } from '../../store/api';
import { GlobalReactQueryOptions } from '../../config';

const MANAGE_SUBSCRIPTION_DATA_QUERY_KEY = 'manageSubscriptionData';

export const useManageSubscriptionData = (
    { page, pageSize, includeExpiredSubscriptions }: SubscriptionParamTypes,
    options: UseQueryOptions<SubscriptionManagementPageDataOut> = {}
) => {
    return useQuery<SubscriptionManagementPageDataOut>(
        [MANAGE_SUBSCRIPTION_DATA_QUERY_KEY, page, pageSize],
        () => fetchManageSubscriptionData({ page, pageSize, includeExpiredSubscriptions }),
        { ...GlobalReactQueryOptions, ...options }
    );
};

export const invalidateManageSubscriptionData = () => {
    return browserClient.invalidateQueries([MANAGE_SUBSCRIPTION_DATA_QUERY_KEY]);
};
